module.exports = __webpack_public_path__ + "static/img/research3.825892b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/research/research3.png
// module id = HhaA
// module chunks = 6